// dev-portal/src/utils/DevPrivateRoute.jsx

import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

export default function DevPrivateRoute({ children }) {
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check if user needs to complete profile
    // BUT only redirect if not already on the complete-profile page
    if (decoded.role_selected === false && location.pathname !== '/complete-profile') {
      return <Navigate to="/complete-profile" replace />;
    }

    // If on complete-profile page but role is already selected, redirect to dashboard
    if (decoded.role_selected === true && location.pathname === '/complete-profile') {
      return <Navigate to="/dashboard" replace />;
    }

    return children;
  } catch (error) {
    console.error('Token decode error:', error);
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
}